import { Box, BoxProps, useTheme } from '@mui/material';

import { PortalTheme } from '@frontend-libs/portal';

import { OpacityAnimation } from './opacity-animation.component';

export interface ViewSectionProps {
  fullWidth?: boolean;
}

export const ViewSection = ({
  fullWidth,
  sx,
  children,
  ...props
}: BoxProps & ViewSectionProps) => {
  const theme = useTheme<PortalTheme>();
  return (
    <Box
      component="section"
      {...props}
      sx={{
        width: '100%',
        maxWidth: fullWidth ? undefined : theme.contentMaxWidth,
        alignSelf: 'center',
        px: fullWidth ? 0 : 2,
        backgroundColor: theme.palette.background.default,
        ...sx,
      }}
    >
      <OpacityAnimation>{children}</OpacityAnimation>
    </Box>
  );
};
